import { Component, HostListener, OnInit } from '@angular/core';
import { HOME } from '../../interfaces/home.interface';
import { HomeService } from '../../services/home.service';
import { homeJson } from './home.json';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { ArticuloService } from 'src/app/www-info/sala-de-prensa/services/articulo.service';
import { forkJoin, catchError, of } from 'rxjs';
import { TwoColAreaComponent } from '../../../../shared/two-col-area/two-col-area.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  // VIDEO

  oneColAreaNoButton_params: any = {
    "preTitle": "EL VALOR, EL COMPROMISO Y LA SOSTENIBILIDAD<BR/>MARCAN LA DIFERENCIA",
    "title": "Zara y Santander, las marcas más valiosas de España",
    "mainText": "",
    "mainButtonText": ""
  }

  videoAuto_params: any = {
    // "videoURL": "https://player.vimeo.com/video/706088405?background=1&autoplay=1&loop=1&byline=0&title=0"
    "videoURL": "https://player.vimeo.com/video/1029371802?background=1&autoplay=1&loop=1&byline=0&title=0"
  }

  hero_video_params: any = {
    "videoURL": "https://player.vimeo.com/video/1030027504?background=1&autoplay=1&loop=1&byline=0&title=0",
    "videoURLMobile": "https://player.vimeo.com/video/1029371802?background=1&autoplay=1&loop=1&byline=0&title=0"
  }


  homeData: any;
  isDataLoaded: boolean = false;
  homePodcast: any;
  homeCase: any;
  homeTeams: any;

  teamMembers: any;

  caso: any;

  constructor(
    private homeService: HomeService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private sanitizer: DomSanitizer,
    private articuloService: ArticuloService
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false; // Can reload the page
    this.route.params.subscribe(params => {
    });


    this.homeService.getHome().subscribe(
      (resp) => {
        this.homeData = resp.data;
        this.homePodcast = resp.retalks;
        this.homeCase = resp.cases;
        this.homeTeams = resp.teammates;



        // Utiliza this.homeCase.id para llamar a getCaso()
        this.homeService.getCaso(this.homeCase.id).subscribe(
          (casoData) => {
            // procesa los datos de casoData aquí
            let casoTmp = casoData;
            this.caso = {
              id: casoTmp.id,
              preTitle: 'CASOS DE ÉXITO',
              photo: 'https://' + casoTmp.imgHome,
              title: casoTmp.title,
              mainText: casoTmp.subtitle,
              mainButtonLink: '/casos-exito/' + casoTmp.id,
              mainButtonText: 'Ver más',
            }
          },
          (error) => {
            console.log('Error al obtener el caso:', error);
          }
        );


        const teamMembersObservables = this.homeTeams.map(member =>
          this.homeService.getTeamMember(member.id).pipe(
            catchError((error) => {
              console.log(`Miembro del equipo con ID ${member.id} no encontrado:`, error);
              return of(null); // Retorna null para miembros no encontrados
            })
          )
        );

        // Usar forkJoin para esperar a que todos los observables se completen
        forkJoin<any[]>(teamMembersObservables).subscribe(
          (teamMembersData) => {
            // Filtrar los miembros que no fueron encontrados (null)
            this.teamMembers = teamMembersData.filter(member => member !== null);
            console.log(`Miembros del equipo cargados: ${this.teamMembers.length}`);
            this.isDataLoaded = true;
          },
          (error) => {
            console.log('Error al obtener los datos de los miembros del equipo:', error);
            this.teamMembers = []; // Asegurar que teamMembers esté inicializado
            this.isDataLoaded = true; // Permitir que la página se cargue
          }
        );





      },
      (error) => {
        console.log(error);
        this.homeData = homeJson;
        this.isDataLoaded = true;
      }
    );


  }
  public safeURL(value: any): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }
  ngOnInit(): void {

    // menu sticky
    window.onscroll = function () {
      var nav = document.getElementById('header');
      if (window.pageYOffset > 200) {
        nav!.classList.add("sticky");
      } else {
        nav!.classList.remove("sticky");
      }
    }

    this.loadHeroVideoParams();

  }

  ngAfterViewInit(): void {


  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.setResponsiveVideo(event.target.innerWidth);
  }

  loadHeroVideoParams(): void {
    this.setResponsiveVideo(window.innerWidth);
    // this.isDataLoaded = true;
  }

  setResponsiveVideo(windowWidth: number): void {
    const isMobile = windowWidth <= 568; // Detecta pantallas pequeñas
    const selectedVideoURL = isMobile ? this.hero_video_params.videoURLMobile : this.hero_video_params.videoURL;

    this.hero_video_params.urlVideoSafe = this.sanitizer.bypassSecurityTrustResourceUrl(selectedVideoURL);

    // Ajusta clases dinámicas según el video
    this.hero_video_params.aspectClass = isMobile ? 'vertical-video' : 'horizontal-video';
  }



}
